import * as React from "react";
import type { SVGProps } from "react";
const SvgWind01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M9.021 4.796c.36-.91 1.222-1.551 2.228-1.551 1.33 0 2.408 1.12 2.408 2.501 0 1.382-1.078 2.502-2.408 2.502H2.4m11.624 10.956c.36.91 1.222 1.551 2.228 1.551 1.33 0 2.408-1.12 2.408-2.501 0-1.382-1.078-2.502-2.408-2.502H7.403m9.38-7.203A2.502 2.502 0 1 1 19.1 12H4.902"
    />
  </svg>
);
export default SvgWind01;
